export const SET_DICTIONARY_DATA = 'SET_DICTIONARY_DATA';

export const setDictionaryData = (data) => ({
  type: SET_DICTIONARY_DATA,
  payload: data,
});
